import z, { ZodType } from 'zod';
import { PlayerMessageItem, playerMessageItemSchema } from './player-message-item';

export type PlayersResponse = {
	deviceId: number;
	players: PlayerMessageItem[];
};

export const playersResponseSchema: ZodType<PlayersResponse> = z.object({
	deviceId: z.number(),
	players: z.array(playerMessageItemSchema),
});
